// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js??ref--1-oneOf-2-1!../../../sass-loader/lib/loader.js!../../../postcss-loader/lib/index.js??postcss!./swiper.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = require("!../../../style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-oneOf-2-1!../../../sass-loader/lib/loader.js!../../../postcss-loader/lib/index.js??postcss!./swiper.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-oneOf-2-1!../../../sass-loader/lib/loader.js!../../../postcss-loader/lib/index.js??postcss!./swiper.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/dist/css/swiper.css
// module id = 207
// module chunks = 0